/**
 * Created by mukund on 7/28/16.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('LMSEmbedController', function ($scope, $state, $filter, $location, $anchorScroll, $rootScope, $interval, $window, $timeout, FileUploader, Principal, SearchService, BatchService, JobService, AssetService, CollectionService, BaseFileService, CaptureService, ProfileService, Tenant, atmosphereService, UploadErrors, $http) {

        Principal.identity().then(function(account) {
            $http({
                method: 'GET',
                url: 'api/properties?name=RESERVES_TITLE'
            }).then(function successCallback(response) {
                $scope.reservesTitle = response.data.value;
            });

//              var message = {
//                subject: 'lti.frameResize',
//                height: '1000px'
//              };
//
//              // Send to the parent window (Brightspace)
//              window.parent.postMessage(JSON.stringify(message), '*');

            $scope.account = account;
            $scope.userName = account.login;
            if($scope.account.firstName || $scope.account.lastName){
                $scope.userFullName = $scope.account.firstName ? $scope.account.firstName : '';
                $scope.userFullName += $scope.account.lastName ? ' ' + $scope.account.lastName : $scope.account.lastName;
            } else {
                $scope.userFullName = $scope.userName;
            }
            $scope.isAuthenticated = Principal.isAuthenticated;
            $scope.createMedia = false;
            $scope.showResultsCnt = false;
            $scope.defaultUploader = true;
            $scope.selectedAssets = [];
            $scope.multiSelect = $state.params.fileSelectType && ($state.params.fileSelectType === "multiple");
            $scope.isPopup = $state.params.windowType && ($state.params.windowType === "popup");
            var queryString = new URLSearchParams(window.location.search);
            $scope.quizSelection = false;
            $scope.assetType = null;
            $scope.quizSelection = false;
            if ($location.search() && $location.search().quizSelection) {
                $scope.quizSelection = $location.search().quizSelection == 'true';
                if ($scope.quizSelection) {
                    $scope.assetType = 'quiz';
                }
            }
            console.log('quizSelection: ',$scope.quizSelection);
            console.log('$$location.search: ',$location.search());
            $scope.enableUpload = $state.params.enableUpload === "true" && !$scope.quizSelection;
            $http({
                method: 'GET',
                url: 'api/properties?name=FEATURE_FLAG_ENABLE_UPLOADER_FOR_INSTRUCTORS'
            }).then(function successCallback(response) {
                if (response.data.value != null) {
                    var enableUploaderForInstructors = response.data.value === 'false' ? false : true;
                    if (!enableUploaderForInstructors && $scope.account.authorities.indexOf("ROLE_ADMIN") == -1) {
                        $scope.enableUpload = false;
                    }
                }
            });

            $http({
                method: 'GET',
                url: 'api/properties?name=FEATURE_FLAG_DEFAULT_UPLOADER'
            }).then(function successCallback(response) {
                if (response.data.value != null) {
                    $scope.defaultUploader = response.data.value;
                }
            });

            $scope.errors = [];
            $scope.assets = [];
            $scope.batch = {};
            $scope.file = {};
            $scope.showAll = true;
            $scope.fromEmptyState = false;
            $scope.backToEmptyStateFlag = false;
            $scope.assetsPerPage = 6;
            $scope.currentPage = 0;
            $scope.search = {};
            $scope.search.query = '';
            $scope.showSpinner = true;
            $scope.busy = false;
            $scope.orderExpression = '+title';
            $scope.sortName = 'Name';
            $scope.type = 'none';

            $scope.orderBy = function(ev) {
                $scope.sortName = ev.target.text;
                $scope.orderExpression = ev.target.dataset.value;
            };

            var content = document.getElementById('content');
            var focusTrap = window.focusTrap(content,
            {
                escapeDeactivates: true
            });
            focusTrap.activate();

            if ($state.params.collectionId) {

                if(self !== top) {
                    // Check if WebRTC is not supported
                    if(!navigator.getUserMedia || ((navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.indexOf('Chrome') < 0) || navigator.userAgent.indexOf('Edge') >= 0 || navigator.userAgent.indexOf('.NET') >= 0 || navigator.userAgent.indexOf('Firefox') >= 0)){
                        $scope.unsupported = true;
                    }
                }
                var getParent = $scope.getParent = function (cid, type) {
                CollectionService.GetCollection.get({cid: cid, type: type}, function(result){
                    $scope.parentCourse = result;
                    $scope.selectedCollectionTitle = result.title;

                    Tenant.info().then(function(data) {

                        $scope.tenantId = data.id;
                        $scope.uploadUrl = data.uploadUrl;
                        $scope.contributor = data.showUserFullName ? $scope.userFullName : $scope.userName;

                        $scope.file.metadata = {
                            title: '',
                            description: '',
                            contributor: $scope.contributor,
                            destination: $scope.parentCourse
                        };

                        $scope.file.sendForCaptioning = false;

                        if(data.captioningServiceList.length && $scope.account.allowCaptionService){
                            $scope.file.canBeCaptioned = true;
                        }

                        // Upload the batch when the user clicks on the upload batch button
                        $scope.uploadBatch = function(){
                            var uploadParams = [{userId: $scope.userName}, {tenantId: $scope.tenantId}];
                            if($scope.file.needsTranscoding) {
                                uploadParams.push({generateThumbnail: true});
                            } else {
                                uploadParams.push({skipProcessing: true});
                            }
                            var addBatchRequest = new BatchService.CreateBatch();
                            addBatchRequest.$save(function(batch){
                                angular.merge($scope.batch, batch);
                                BaseFileService.GetUploadToken.get(function(data){
                                    uploadParams.push({jwt: data.token});
                                    var fileItem = $scope.batch.uploader.queue[0];
                                    fileItem.formData = uploadParams;
                                    fileItem.url = $scope.uploadUrl;
                                    fileItem.upload();
                                    $scope.file.uploadStarted = true;
                                }, function(){
                                    $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.GET_UPLOAD_TOKEN.formatMessage({name: $scope.file.name})});
                                    // Cancel & Remove the file from the file list since this is a fatal error
                                    $scope.cancelFile();
                                });
                            }, function(){
                                $scope.errors.push({id: 'ee' + Date.now(),msg: UploadErrors.CREATE_BATCH});
                            });
                        };
                    });

                    // This is used to fetch all assets or search for assets
                    var searchAssets = $scope.searchAssets = function (reset) {

                        if (reset===undefined) {
                            reset = false;
                        }
                        if ($scope.busy) {
                            return;
                        }

                        //Check for end of list
                        if(!reset && $scope.assets.length === $scope.totalAssets){
                            if($scope.origTotalAssets){
                                console.log('$scope.origAssetList: ', $scope.origAssetList);
                                $scope.assets = $scope.origAssetList;
                                $scope.totalAssets = $scope.origTotalAssets;
                            }
                            $scope.showSpinner = false;
                            return;
                        }
                        $scope.busy = true;
                        $scope.showSpinner = true;
                        var page = $scope.currentPage + 1;
                        $scope.currentPage = page;
                        SearchService.SearchAssets.get({query: $scope.search.query, sitewide: false, cid: $state.params.collectionId, limit: $scope.assetsPerPage, offset: (page - 1) * $scope.assetsPerPage, type: $scope.type, assetType: $scope.assetType}, function(assetList){
                            $scope.showSpinner = false;
                            $scope.assets.push(...assetList.contents);
                            $scope.assets.forEach(function(asset){
                                asset.selected = ($scope.selectedAssets.map(function(e) { return e.xid; }).indexOf(asset.xid)) > -1;
                            });
                            $scope.totalAssets = assetList.totalContents;
                            $scope.showResultsCnt = $scope.search.query ? true : false;
                            $scope.showSpinner = false;
                            $scope.busy = false;
                        });

                    };

                    $scope.clickUploader = function () {
                        $('#single-uploader-input').click();
                    };

                    var resetAll = $scope.resetAll = function(){
                        $scope.assets =[];
                        $scope.selectedAssets = [];
                        $scope.totalAssets = 0;
                        $scope.currentPage = 0;
                        $scope.busy = false;
                        searchAssets(true);
                        $scope.backToEmptyStateFlag = false;
                    };

                    var enableEmptyState = $scope.enableEmptyState = function(){
                        $scope.fromEmptyState = true;
                        $scope.backToEmptyStateFlag = false;
                    }

                    var checkEmptyState = $scope.checkEmptyState = function(){
                        if($scope.fromEmptyState){
                            $scope.fromEmptyState = false;
                            $scope.backToEmptyStateFlag = true;
                            $scope.search.query = '';
                        }
                    }

                    $scope.switchType = function (type) {
                        if (type===undefined) {
                            type = 'none';
                            $scope.selectedCollectionTitle = $scope.parentCourse.title;
                        }else{
                            $scope.selectedCollectionTitle = $scope.reservesTitle;
                        }
                        $scope.type = type;
                        resetAll();
                    };

                    searchAssets();

                    $scope.cancelSearch = function(){
                        $scope.search.query = '';
                        searchAssets();
                    };

                    $scope.showAllAssets = function(state){
                        $scope.showAll = state;
                    };

                    // Cancel Operations
                    $scope.cancelFile = function() {
                        var fileId = $scope.file.fileId ? $scope.file.fileId : $scope.file.mediacloudFileId;
                        if(fileId){
                            // Cancel the basefile entry first, if it already exists before updating the UI
                            BaseFileService.CancelBaseFile.erase({id: fileId}, function(){
                                $scope.closeUploader(true);
                            }, function(){
                                $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                            });
                        } else {
                            $scope.closeUploader(true);
                        }
                    };

                    $scope.updateFileMetadata = function(){
                        var fileId = $scope.file.fileId ? $scope.file.fileId : $scope.file.mediacloudFileId;
                        if(fileId){
                            var baseFileResource = new BaseFileService.AddMetadata({
                                id: fileId,
                                title: $scope.file.metadata.title,
                                contributor: $scope.file.metadata.contributor,
                                description: $scope.file.metadata.description.trim(),
                                isStudentUpload: false
                            });
                            baseFileResource.$save(function(){
                            }, function(){
                                $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.UPDATE_FILE_METADATA});
                            });
                        }
                    };

                    $scope.closeUploader = function(reload){
                        $scope.batch.uploader.cancelAll();
                        $scope.batch.uploader.clearQueue();
                        if(reload) {
                            $state.reload();
                        }
                    };

                    $scope.checkForEnterKey = function(event, action){
                        if(event.keyCode === 13){
                            if(action === 'search'){
                                resetAll();
                            }else if(action === 'searchFromEmptyState'){
                                $scope.fromEmptyState = true;
                                $scope.backToEmptyStateFlag = false;
                                resetAll();
                            } else if(action === 'showSelectedAssets'){
                                $scope.showAllAssets(false);
                            } else if(action === 'showAllAssets'){
                                $scope.showAllAssets(true);
                            }
                        }
                    };

                    $scope.setType = function(type){
                        $scope.type = type;
                    }

                    $scope.addMedia = function(){
                        var files = [];
                        if($scope.selectedAssets.length > 0) {
                            // Browse
                            $scope.selectedAssets.forEach(function(asset){
                                files.push({id: asset.xid, name: asset.title, type: asset.type, parentCollectionId: asset.parent.cid, rootCollectionId: $state.params.collectionId });
                            });
                        } else if($scope.file && $scope.file.uploadComplete) {
                            // Upload
                            files.push({id: $scope.file.fileId, name: $scope.file.metadata.title,  type: 'asset', parentCollectionId: $state.params.collectionId, rootCollectionId: $state.params.collectionId });
                        }
                        if(files.length > 0){
                            AssetService.AddMedia.embed(files,function(data){
                                focusTrap.deactivate();
                                console.log("Added Media Files");
                                if(data.lmsType == 'quip'){
                                 parent.postMessage({
                                    event_id: 'mediaCloud_quip_message',
                                     data: {
                                         v1: files
                                     }
                                 },
                                 "*");
                                } else if(data.lmsType == 'moodle' && data.moodleEmbed === "on"){
                                    $http({
                                        method: 'POST',
                                        url: 'api/lms/embed/moodle'
                                    }).then(function successCallback(response) {
                                         const assetToCopy = [];
                                         $scope.selectedAssets.forEach(function(asset){
                                             if(!asset.path.includes($state.params.collectionId)){
                                                 assetToCopy.push(asset.xid);
                                             }
                                         });
                                         var assetCopyResource = new AssetService.CopyAsset({
                                             destinationCollectionId: $state.params.collectionId,
                                             assetIds:assetToCopy
                                         });
                                         var savePromise = assetCopyResource.$save();
                                         savePromise.then(function(){
                                             console.log("asset(s) copied.");
                                             window.location=response.data.moodle_return_url;
                                         })
                                         .catch(function (error) {
                                             console.log("asset(s) cannot be copied");
                                             alert("Please try again!");
                                         })

                                    }, function errorCallback(response) {
                                        console.log(response);
                                    });
                                }
                                else if(data.lmsType == 'moodle' && data.contentItemReturnUrl === "" && data.ltiVersion != "1.3.0"){
                                    const assetToCopy = [];
                                    $scope.selectedAssets.forEach(function(asset){
                                        if(!asset.path.includes($state.params.collectionId)){
                                            assetToCopy.push(asset.xid);
                                        }
                                    });
                                    var assetCopyResource = new AssetService.CopyAsset({
                                        destinationCollectionId: $state.params.collectionId,
                                        assetIds:assetToCopy
                                    });
                                    var savePromise = assetCopyResource.$save();
                                    savePromise.then(function(){
                                        console.log("asset(s) copied.");
                                        jQuery.ajax({
                                            url: "api/lms/js",
                                            dataType: 'script',
                                            headers: {'x-auth-token': $http.defaults.headers.common['x-auth-token'] },
                                            success: function(){
                                                console.log('Remote LMS JS Loaded.');
                                                loadLMSJS(files[0].id);
                                            },
                                            error: function() {
                                                alert('Remote LMS JS Load failed!!');
                                            }
                                        });
                                    })
                                    .catch(function (error) {
                                        console.log("asset(s) cannot be copied");
                                        alert("Please try again!");
                                    })
                                }else{
                                    $http({
                                        method: 'GET',
                                        url: 'api/lms/embed'
                                    }).then(function successCallback(response) {
                                        const assetToCopy = [];
                                        console.log(response.data.redirectUrl);
                                        $scope.selectedAssets.forEach(function(asset){
                                            if(!asset.path.includes($state.params.collectionId)){
                                                assetToCopy.push(asset.xid);
                                            }
                                        });
                                        var assetCopyResource = new AssetService.CopyAsset({
                                            destinationCollectionId: $state.params.collectionId,
                                            assetIds:assetToCopy
                                        });
                                        var savePromise = assetCopyResource.$save();
                                        savePromise.then(function(){
                                            console.log("asset(s) copied.");
                                            //Check for content item message
                                            // Make the form post
                                            if(response.data.params){
                                                'use strict';
                                                var form;
                                                form = $('<form />', {
                                                    action: response.data.redirectUrl,
                                                    method: "POST",
                                                    style: 'display: none;'
                                                });
                                                if (typeof response.data.params !== 'undefined' && response.data.params !== null) {
                                                    $.each(response.data.params, function (name, value) {
                                                        $('<input />', {
                                                            type: 'hidden',
                                                            name: name,
                                                            value: value
                                                        }).appendTo(form);
                                                    });
                                                }
                                                form.appendTo('body').submit();
                                            }else{
                                                window.location=response.data.redirectUrl;
                                            }
                                        })
                                        .catch(function (error) {
                                            console.log("asset(s) cannot be copied");
                                            alert("Please try again!");
                                        })

                                    }, function errorCallback(response) {
                                        console.log(response);
                                    });
                                }

                            }, function(){
                                $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.EMBED});
                            });
                        }
                    };

                    $scope.showCreateMedia = function() {
                        if(!$scope.unsupported){
                            $scope.createMedia = true;
                        }
                    };

                    var setSearchPlaceHolder = function(){
                        if($window.innerWidth < 600){
                            $('#search-bar').attr('placeholder','Search...');
                        }else {
                            $('#search-bar').attr('placeholder','Search for ShareStream Media...');
                        }
                    };

                    // Called on initial page load
                    setSearchPlaceHolder();

                    // Called on window resize
                    angular.element($window).bind('resize', function () {
                        setSearchPlaceHolder();
                    });
                });
                };

                getParent($state.params.collectionId,'COURSE');

                $http({
                   method: 'GET',
                   url: 'api/properties?name=ENABLE_RECORD_BUTTON'
                }).then(function successCallback(response) {
                   $scope.enableRecordButton = response.data.value === "true" ? true : false;
                   console.log("enableRecordButton: ", $scope.enableRecordButton);
                });

                /*// Collection Tree
                 var num = 1;
                 var getNum = function (){
                 return num++;
                 };

                 var createSubTree = function(level) {
                 if (level > 0)
                 return [
                 { "label" : "Node " + getNum(), "id" : "id", "children": createSubTree(level-1) },
                 { "label" : "Node " + getNum(), "id" : "id", "children": createSubTree(level-1) },
                 { "label" : "Node " + getNum(), "id" : "id", "children": createSubTree(level-1) },
                 { "label" : "Node " + getNum(), "id" : "id", "children": createSubTree(level-1) }
                 ];
                 else
                 return [];
                 };
                 $scope.treedata=createSubTree(7);

                 $scope.showSelected = function(sel) {
                 $scope.selected = sel.label;
                 };

                 $scope.addRoot = function() {
                 $scope.treedata.push({ "label" : "New Node " + getNum(), "id" : "id", "children": [] });
                 };
                 $scope.addChild = function() {
                 $scope.treedata[0].children.push({ "label" : "New Node " + getNum(), "id" : "id", "children": [] });
                 }; */
            }

        });
    });
